import { gateway } from './api';
import { isAuthenticated } from './auth';

export const SETTINGS_STORAGE_KEY = 'settings';
export const WHITE_LABEL_SETTINGS_PATH = 'webbff/lit_app_web/settings/white-label';

const isSettingsObject = value => typeof value === 'object' && value !== null;

function hasValidStoredSettings() {
  try {
    return isSettingsObject(JSON.parse(localStorage.getItem(SETTINGS_STORAGE_KEY)));
  } catch (error) {
    return false;
  }
}

export function discardInvalidStoredSettings() {
  if (localStorage.getItem(SETTINGS_STORAGE_KEY) !== null && !hasValidStoredSettings()) {
    localStorage.removeItem(SETTINGS_STORAGE_KEY);
  }
}

export async function fetchWhiteLabelSettings() {
  discardInvalidStoredSettings();
  if (!isAuthenticated()) {
    return;
  }
  const settings = await gateway.get(WHITE_LABEL_SETTINGS_PATH);
  if (isSettingsObject(settings)) {
    localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  }
}
